module.exports = ".mobile-map{\n  width: 100%;\n  height: 93%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/+app/+contacts/contacts.component.css
// module id = 583
// module chunks = 0